import { render, staticRenderFns } from "./SpyderTechnologyIcon.vue?vue&type=template&id=3afeee3f"
import script from "./SpyderTechnologyIcon.vue?vue&type=script&lang=js"
export * from "./SpyderTechnologyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports